import { render, staticRenderFns } from "./RentalObjects.vue?vue&type=template&id=0ee8778d&"
import script from "./RentalObjects.vue?vue&type=script&lang=js&"
export * from "./RentalObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports